import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';

type Audience = 'cliente' | 'despachante' | 'cartorio';

@Component({
    selector: 'sfc-landing',
  templateUrl: './sfc-landing.component.html',
    styleUrls: ['./sfc-landing.component.scss'],
    providers: [ConfirmationService, MessageService],
    encapsulation: ViewEncapsulation.None
})

export class SfcLandingComponent  {
    audience: Audience = 'cliente';
    currentYear: number = new Date().getFullYear();

    benefits = [
        { icon: 'pi pi-list-check', title: 'Checklist inteligente', description: 'Saiba exatamente o que precisa enviar para cada serviço, sem adivinhação.' },
        { icon: 'pi pi-clock', title: 'Menos retrabalho', description: 'A CartórIA ajuda a identificar problemas comuns antes de enviar ao cartório.' },
        { icon: 'pi pi-map-marker', title: 'Cartório mais perto', description: 'Escolha cartórios parceiros próximos e mantenha todo o processo rastreável.' },
        { icon: 'pi pi-mobile', title: 'Acompanhamento em tempo real', description: 'Status, prazos, histórico e atualizações — tudo na palma da mão.' }
    ];

    steps = [
        { title: 'Diga o que você precisa', description: 'Escolha o serviço e informe sua cidade.' },
        { title: 'Escolha o cartório parceiro', description: 'Veja opções disponíveis perto de você.' },
        { title: 'Envie os documentos online', description: 'A CartórIA confere tudo antes de enviar ao cartório.' },
        { title: 'Acompanhe em tempo real', description: 'Status, prazos, histórico e chat com o responsável.' },
        { title: 'Só vá ao cartório quando for necessário', description: 'Para assinatura ou retirada — ou receba em casa, se o cartório disponibilizar motoboy.' }
    ];

    constructor(private router: Router) {}

    setAudience(a: Audience) {
      this.audience = a;
    }

    scrollTo(id: string) {
      const el = document.getElementById(id);
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    navigateToLogin(): void {
        this.router.navigate(['/login']);
    }

    get audienceTitle() {
      switch (this.audience) {
        case 'cliente':
          return 'Para você (cliente final)';
        case 'despachante':
          return 'Para despachantes';
        case 'cartorio':
          return 'Para cartórios parceiros';
      }
    }

    get audienceBullets(): string[] {
      if (this.audience === 'cliente') {
        return [
          'Crie sua conta gratuita e solicite serviços com orientação passo a passo.',
          'Envie documentos online e acompanhe cada etapa do pedido em tempo real.',
          'Fale direto com o responsável pelo seu atendimento, sem ficar no escuro.',
        ];
      }
      if (this.audience === 'despachante') {
        return [
          'Atenda múltiplos clientes em um único painel, com organização e histórico.',
          'Reduza deslocamentos com envio digital e checklist automático de documentos.',
          'Ganhe velocidade no atendimento com automações e comunicação centralizada.',
        ];
      }
      return [
        'Gerencie pedidos, prazos e atendimento em um painel único e organizado.',
        'Use CartórIA para reduzir erros de documentação e retrabalho.',
        'Acelere processos com agentes e automações, mantendo segurança e rastreabilidade.',
      ];
    }

    // CTA handlers
    onPrimaryCta() {
      this.router.navigate(['/login/signup']);
    }

    onSecondaryCta() {
      this.scrollTo('como-funciona');
    }
  }
